// import { X } from "lucide-react";
// import { useEffect } from "react";
// import { useForm } from "react-hook-form";
// import { useUpdateGlobalConfig } from "../hooks/updateGlobalConfig";
// import { useResetGlobalConfig } from "../hooks/resetGlobalConfig";

// export const EditGlobalModal = ({ isOpen, onClose, defaultValues }) => {
//     const { mutate: updateConfig, isPending } = useUpdateGlobalConfig();
//     const { mutate: resetConfig, isPending: isResetting } = useResetGlobalConfig();

//     const {
//         register,
//         handleSubmit,
//         reset,
//         formState: { errors },
//     } = useForm({
//         defaultValues: {
//             search_radius_in_meter: defaultValues?.search_radius_in_meter,
//             min_age: defaultValues?.min_age,
//             max_age: defaultValues?.max_age,
//             platform_fees: defaultValues?.platform_fees,
//             gst_percentage: defaultValues?.gst_percentage,
//              booking_commission_percentage: defaultValues?.booking_commission_percentage,
//     booking_commission_waiver_days: defaultValues?.booking_commission_waiver_days,
//         support_contact_number: defaultValues?.support_contact_number,

//         },
//     });

//     // Fill form when modal opens
//     useEffect(() => {
//         if (isOpen && defaultValues) {
//             reset({
//                 search_radius_in_meter: defaultValues.search_radius_in_meter,
//                 min_age: defaultValues.min_age,
//                 max_age: defaultValues.max_age,
//                 platform_fees: defaultValues.platform_fees,
//                 gst_percentage: defaultValues.gst_percentage,
//                 booking_commission_percentage: defaultValues.booking_commission_percentage,
//     booking_commission_waiver_days: defaultValues.booking_commission_waiver_days,
//         support_contact_number: defaultValues.support_contact_number,

//             });
//         }
//     }, [isOpen, defaultValues, reset]);

//     if (!isOpen) return null;

//     // Submit handler
//     const onSubmit = (data) => {
//         const payload = {
//             search_radius_in_meter: Number(data.search_radius_in_meter),
//             min_age: Number(data.min_age),
//             max_age: Number(data.max_age),
//             platform_fees: Number(data.platform_fees),
//             gst_percentage: Number(data.gst_percentage),
//              booking_commission_percentage: Number(data.booking_commission_percentage),
//     booking_commission_waiver_days: Number(data.booking_commission_waiver_days),
//         support_contact_number: data.support_contact_number,

//         };

//         updateConfig(payload, {
//             onSuccess: () => onClose(),
//         });
//     };

//     // Reset configuration
//     const handleReset = () => {
//         resetConfig(undefined, {
//             onSuccess: (res) => {
//                 const newValues = res.data;
//                 reset({
//                     search_radius_in_meter: newValues.search_radius_in_meter,
//                     min_age: newValues.min_age,
//                     max_age: newValues.max_age,
//                     platform_fees: newValues.platform_fees,
//                     gst_percentage: newValues.gst_percentage,
//                 });
//                 onClose();
//             },
//         });
//     };

//     return (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
//             <div className="bg-card rounded-lg shadow-xl w-full max-w-md border border-border">

//                 {/* Header */}
//                 <div className="flex items-center justify-between px-6 py-4 border-b border-border">
//                     <h3 className="text-lg font-semibold text-foreground">Edit Preferences</h3>
//                     <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
//                         <X size={20} />
//                     </button>
//                 </div>

//                 <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-5">

//                     {/* Search Radius */}
//                     <div>
//                         <label className="block text-sm text-muted-foreground mb-1">
//                             Search Radius (meters)
//                         </label>
//                         <input
//                             type="number"
//                             {...register("search_radius_in_meter", {
//                                 required: "Search radius is required",
//                             })}
//                             className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                         />
//                         {errors.search_radius_in_meter && (
//                             <p className="text-destructive text-xs mt-1">
//                                 {errors.search_radius_in_meter.message}
//                             </p>
//                         )}
//                     </div>

//                     {/* Min Age */}
//                     {/* <div>
//                         <label className="block text-sm text-muted-foreground mb-1">Min Age</label>
//                         <input
//                             type="number"
//                             {...register("min_age", {
//                                 required: "Minimum age is required",
//                             })}
//                             className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                         />
//                         {errors.min_age && (
//                             <p className="text-destructive text-xs mt-1">{errors.min_age.message}</p>
//                         )}
//                     </div> */}

//                     {/* Max Age */}
//                     {/* <div>
//                         <label className="block text-sm text-muted-foreground mb-1">Max Age</label>
//                         <input
//                             type="number"
//                             {...register("max_age", {
//                                 required: "Maximum age is required",
//                             })}
//                             className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                         />
//                         {errors.max_age && (
//                             <p className="text-destructive text-xs mt-1">{errors.max_age.message}</p>
//                         )}
//                     </div> */}

//                     {/* PlatForm Fees */}
//                     <div>
//                         <label className="block text-sm text-muted-foreground mb-1">Platform Fees</label>
//                         <input
//                             type="number"
//                             {...register("platform_fees", {
//                                 required: "Platform fees is required",
//                             })}
//                             className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                         />
//                         {errors.platform_fees && (
//                             <p className="text-destructive text-xs mt-1">{errors.platform_fees.message}</p>
//                         )}
//                     </div>

//                     {/* GST Percentage */}
//                     <div>
//                         <label className="block text-sm text-muted-foreground mb-1">GST Percentage</label>
//                         <input
//                             type="number"
//                             {...register("gst_percentage", {
//                                 required: "GST percentage is required",
//                             })}
//                             className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                         />
//                         {errors.gst_percentage && (
//                             <p className="text-destructive text-xs mt-1">{errors.gst_percentage.message}</p>
//                         )}
//                     </div>

//                     {/* Booking Commission Percentage */}
// <div>
//     <label className="block text-sm text-muted-foreground mb-1">
//         Booking Commission (%)
//     </label>
//     <input
//         type="number"
//         {...register("booking_commission_percentage", {
//             required: "Booking commission percentage is required",
//         })}
//         className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//     />
//     {errors.booking_commission_percentage && (
//         <p className="text-destructive text-xs mt-1">
//             {errors.booking_commission_percentage.message}
//         </p>
//     )}
// </div>

// {/* Booking Commission Waiver Days */}
// <div>
//     <label className="block text-sm text-muted-foreground mb-1">
//         Commission Waiver Days
//     </label>
//     <input
//         type="number"
//         {...register("booking_commission_waiver_days", {
//             required: "Commission waiver days is required",
//         })}
//         className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//     />
//     {errors.booking_commission_waiver_days && (
//         <p className="text-destructive text-xs mt-1">
//             {errors.booking_commission_waiver_days.message}
//         </p>
//     )}
// </div>

// <div>
//     <label className="block text-sm text-muted-foreground mb-1">
//         Support Contact Number
//     </label>

//     <input
//         type="text"
//         {...register("support_contact_number", {
//             required: "Support contact number is required",
//         })}
//         className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//     />

//     {errors.support_contact_number && (
//         <p className="text-destructive text-xs mt-1">
//             {errors.support_contact_number.message}
//         </p>
//     )}
// </div>

// {/* Buttons */}
// <div className="flex gap-3"></div>

//                     {/* Buttons */}
//                     <div className="flex gap-3">


//                         {/* RESET BUTTON */}
//                         <button
//                             type="button"
//                             disabled={isPending || isResetting}
//                             onClick={handleReset}
//                             className="px-4 py-2 border border-destructive text-destructive rounded-md hover:bg-destructive hover:text-white disabled:opacity-50 transition-colors"
//                         >
//                             {isResetting ? "Resetting..." : "Reset to Default"}
//                         </button>

//                         <button
//                             type="button"
//                             disabled={isPending}
//                             onClick={onClose}
//                             className="px-4 py-2 border border-border text-muted-foreground rounded-md hover:bg-accent hover:text-foreground transition-colors"
//                         >
//                             Cancel
//                         </button>

//                         <button
//                             type="submit"
//                             disabled={isPending}
//                             className="px-4 py-2 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md transition-colors disabled:opacity-50"
//                         >
//                             {isPending ? "Updating..." : "Update settings"}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };





import { X } from "lucide-react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useUpdateGlobalConfig } from "../hooks/updateGlobalConfig";
import { useResetGlobalConfig } from "../hooks/resetGlobalConfig";

export const EditGlobalModal = ({ isOpen, onClose, defaultValues }) => {
  const { mutate: updateConfig, isPending } = useUpdateGlobalConfig();
  const { mutate: resetConfig, isPending: isResetting } =
    useResetGlobalConfig();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      search_radius_in_meter: defaultValues?.search_radius_in_meter,
      min_age: defaultValues?.min_age,
      max_age: defaultValues?.max_age,
      platform_fees: defaultValues?.platform_fees,
      gst_percentage: defaultValues?.gst_percentage,
      booking_commission_percentage:
        defaultValues?.booking_commission_percentage,
      booking_commission_waiver_days:
        defaultValues?.booking_commission_waiver_days,
      support_contact_number: defaultValues?.support_contact_number,
      support_contact_email: defaultValues?.support_contact_email,
    },
  });

  // Fill form when modal opens
  useEffect(() => {
    if (isOpen && defaultValues) {
      reset({
        search_radius_in_meter: defaultValues.search_radius_in_meter,
        min_age: defaultValues.min_age,
        max_age: defaultValues.max_age,
        platform_fees: defaultValues.platform_fees,
        gst_percentage: defaultValues.gst_percentage,
        booking_commission_percentage:
          defaultValues.booking_commission_percentage,
        booking_commission_waiver_days:
          defaultValues.booking_commission_waiver_days,
        support_contact_number: defaultValues.support_contact_number,
        support_contact_email: defaultValues.support_contact_email,
      });
    }
  }, [isOpen, defaultValues, reset]);

  if (!isOpen) return null;

  // Submit handler
  const onSubmit = (data) => {
    const payload = {
      search_radius_in_meter: Number(data.search_radius_in_meter),
      min_age: Number(data.min_age),
      max_age: Number(data.max_age),
      platform_fees: Number(data.platform_fees),
      gst_percentage: Number(data.gst_percentage),
      booking_commission_percentage: Number(data.booking_commission_percentage),
      booking_commission_waiver_days: Number(
        data.booking_commission_waiver_days,
      ),
      support_contact_number: data.support_contact_number,
      support_contact_email: data.support_contact_email,
    };

    updateConfig(payload, {
      onSuccess: () => onClose(),
    });
  };

  // Reset configuration
  const handleReset = () => {
    resetConfig(undefined, {
      onSuccess: (res) => {
        const newValues = res.data;
        reset({
          search_radius_in_meter: newValues.search_radius_in_meter,
          min_age: newValues.min_age,
          max_age: newValues.max_age,
          platform_fees: newValues.platform_fees,
          gst_percentage: newValues.gst_percentage,
          booking_commission_percentage:
            newValues.booking_commission_percentage,
          booking_commission_waiver_days:
            newValues.booking_commission_waiver_days,
          support_contact_number: newValues.support_contact_number,
          support_contact_email: newValues.support_contact_email,
        });
        onClose();
      },
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-xl w-full max-w-md border border-border">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-border">
          <h3 className="text-lg font-semibold text-foreground">
            Edit Preferences
          </h3>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground"
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="p-6 space-y-5">
          {/* Search Radius */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Search Radius (meters)
            </label>
            <input
              type="number"
              {...register("search_radius_in_meter", {
                required: "Search radius is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            {errors.search_radius_in_meter && (
              <p className="text-destructive text-xs mt-1">
                {errors.search_radius_in_meter.message}
              </p>
            )}
          </div>

          {/* Min Age */}
          {/* <div>
                        <label className="block text-sm text-muted-foreground mb-1">Min Age</label>
                        <input
                            type="number"
                            {...register("min_age", {
                                required: "Minimum age is required",
                            })}
                            className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                        />
                        {errors.min_age && (
                            <p className="text-destructive text-xs mt-1">{errors.min_age.message}</p>
                        )}
                    </div> */}

          {/* Max Age */}
          {/* <div>
                        <label className="block text-sm text-muted-foreground mb-1">Max Age</label>
                        <input
                            type="number"
                            {...register("max_age", {
                                required: "Maximum age is required",
                            })}
                            className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                        />
                        {errors.max_age && (
                            <p className="text-destructive text-xs mt-1">{errors.max_age.message}</p>
                        )}
                    </div> */}

          {/* PlatForm Fees */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Platform Fees
            </label>
            <input
              type="number"
              {...register("platform_fees", {
                required: "Platform fees is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            {errors.platform_fees && (
              <p className="text-destructive text-xs mt-1">
                {errors.platform_fees.message}
              </p>
            )}
          </div>

          {/* GST Percentage */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              GST Percentage
            </label>
            <input
              type="number"
              {...register("gst_percentage", {
                required: "GST percentage is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            {errors.gst_percentage && (
              <p className="text-destructive text-xs mt-1">
                {errors.gst_percentage.message}
              </p>
            )}
          </div>

          {/* Booking Commission Percentage */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Booking Commission (%)
            </label>
            <input
              type="number"
              {...register("booking_commission_percentage", {
                required: "Booking commission percentage is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            {errors.booking_commission_percentage && (
              <p className="text-destructive text-xs mt-1">
                {errors.booking_commission_percentage.message}
              </p>
            )}
          </div>

          {/* Booking Commission Waiver Days */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Commission Waiver Days
            </label>
            <input
              type="number"
              {...register("booking_commission_waiver_days", {
                required: "Commission waiver days is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            {errors.booking_commission_waiver_days && (
              <p className="text-destructive text-xs mt-1">
                {errors.booking_commission_waiver_days.message}
              </p>
            )}
          </div>

          {/* Support Contact Number */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Support Contact Number
            </label>

            <input
              type="text"
              {...register("support_contact_number", {
                required: "Support contact number is required",
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />

            {errors.support_contact_number && (
              <p className="text-destructive text-xs mt-1">
                {errors.support_contact_number.message}
              </p>
            )}
          </div>

          {/* Support Contact Email */}
          <div>
            <label className="block text-sm text-muted-foreground mb-1">
              Support Contact Email
            </label>

            <input
              type="email"
              {...register("support_contact_email", {
                required: "Support contact email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter a valid email address",
                },
              })}
              className="w-full px-3 py-2 bg-input border border-border rounded-md text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
            />

            {errors.support_contact_email && (
              <p className="text-destructive text-xs mt-1">
                {errors.support_contact_email.message}
              </p>
            )}
          </div>

          {/* Buttons */}
          <div className="flex gap-3">
            {/* RESET BUTTON */}
            <button
              type="button"
              disabled={isPending || isResetting}
              onClick={handleReset}
              className="px-4 py-2 border border-destructive text-destructive rounded-md hover:bg-destructive hover:text-white disabled:opacity-50 transition-colors"
            >
              {isResetting ? "Resetting..." : "Reset to Default"}
            </button>

            <button
              type="button"
              disabled={isPending}
              onClick={onClose}
              className="px-4 py-2 border border-border text-muted-foreground rounded-md hover:bg-accent hover:text-foreground transition-colors"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={isPending}
              className="px-4 py-2 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md transition-colors disabled:opacity-50"
            >
              {isPending ? "Updating..." : "Update settings"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
